import type {
  GetHotelByIDParams,
  HotelResponse,
} from '@/api/hotelContentApi/client';
import type {HotelDetails} from '@/api/hoteldetails';
import type {DescriptionCuratedItem} from '@/api/hoteldetails/client';

import {queryOptions} from '@tanstack/react-query';

import {getHotelByID} from '@/api/hotelContentApi/client';

export const singleHotel = (hotelId: string, params: GetHotelByIDParams) => {
  return queryOptions({
    queryKey: ['hotel-content', 'single-hotel', hotelId, params],
    queryFn: async ({signal}) => {
      const response = await getHotelByID(hotelId, params, {signal});
      if (response.status !== 200) {
        throw new Error(`Failed to fetch hotel content for ${hotelId}`);
      }

      return mapData(response.data);
    },
  });
};

// TODO Remove mapping when A/B test is through
const mapData = (data: HotelResponse): HotelDetails => {
  const {masterData, inviaAttributes} = data;

  return {
    id: data.id,
    lat: masterData.coordinates?.lat,
    lng: masterData.coordinates?.lon,
    name: masterData.name ?? '',
    category: masterData.category?.value,
    categoryType: (masterData.category?.categoryType ??
      'unverified') as HotelDetails['categoryType'],
    isSustainable: Boolean(masterData.greenCertificate),
    sustainableCertifier: masterData.greenCertificate?.certification,
    address: {
      country: masterData.location?.countryName,
      countryCode: masterData.location?.countryCode,
      city: masterData.location?.cityName,
      zip: masterData.address?.zipCode,
      street: masterData.address?.street,
      streetNumber: masterData.address?.streetNo,
      region: masterData.location?.regionName,
    },
    descriptionCurated: (data.description?.map(({description, title}) => ({
      title,
      content: description,
    })) ?? []) as Array<DescriptionCuratedItem>,
    attributes: (inviaAttributes ?? []).map((group) => ({
      name: group.code,
      translation: group.name,
      ...(group.attributes
        ? {
            attributes: group.attributes.map((attribute) => ({
              name: attribute.code,
              translation: attribute.name,
              value: attribute.value ?? '',
            })),
          }
        : null),
    })) as HotelDetails['attributes'],
    images: [],
  };
};
